// src/api/usersClient.ts
import { apiUrl } from "../config/api";

export type GetOrCreateUserResponse = {
  userId: number;
  email?: string | null;
  postcode?: string | null;
};

export async function getOrCreateUser(email: string, postcode?: string | null) {
  // Adjust to your real endpoint if needed.
  // Typical BootLoop pattern: POST /api/users/resolve OR /api/users/get-or-create
  const res = await fetch(apiUrl(`/api/users/get-or-create`), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, postcode: postcode ?? null }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`GetOrCreateUser failed (${res.status}): ${text}`);
  }

  const json = (await res.json()) as GetOrCreateUserResponse;

  if (!json.userId || json.userId <= 0) {
    throw new Error("GetOrCreateUser returned an invalid userId.");
  }

  return json;
}